const prefix = 'formfield';
export const DATA_HOOKS = {
    suffix: `${prefix}-suffix`,
    counter: `${prefix}-counter`,
    children: `${prefix}-children`,
    label: `${prefix}-label`,
    asterisk: `${prefix}-asterisk`,
    infoIcon: `${prefix}-infoicon`,
    statusMessage: `${prefix}-statusmessage`,
};
export const PLACEMENT = {
    top: 'top',
    right: 'right',
    left: 'left',
};
export const ALIGN = {
    middle: 'middle',
    top: 'top',
};
export const STATUS = {
    error: 'error',
    warning: 'warning',
    loading: 'loading',
};
export const LABEL_SIZE = {
    tiny: 'tiny',
    small: 'small',
};
//# sourceMappingURL=FormField.constants.js.map